exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".week-row{width:100%;border-left:1px solid #e0e0e0;display:flex;cursor:pointer}.week-number{border:1px solid #e1e1e1;border-right:0;border-radius:5px 0 0 5px;background-color:#fafafa;text-align:right;position:absolute;width:70px;left:-71px;padding:8px 5px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-57354b87","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/Week.vue
// module id = 137
// module chunks = 0 1